import React, { useState, useEffect } from "react";
import logoHorizontalBlanco from "../../../../static/img/logo_horizontal.png";
import "../../../styles/styles.css";
import { useNavigate } from 'react-router-dom';
import { requestPassword } from '../../../../services/authApi';
import CuadroTexto from "../../../../static/assets/cuadroTexto/cuadroTexto";
import LoadingScreen from "../../../../static/assets/loadingScreen/loadingScreen"; 

export const PasswordResetRequest = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError('');
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setEmailError('Por favor, introduce un correo electrónico válido.');
      return;
    }

    setLoading(true);
    try {
      await requestPassword({ email });
      setMessage(`Enlace de recuperación enviado a: ${email}`);

      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setMessage('Hubo un error al restablecer la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.body.classList.add('no-footer-padding');
    return () => {
      document.body.classList.remove('no-footer-padding');
    };
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }
  
  return (
    <div className="intro">
      {/* Mostrar el cuadro de texto si hay un mensaje */}
      {message && (
        <CuadroTexto 
          message={message} 
          onAccept={() => setMessage("")} 
          showCancel={false} 
        />
      )}

      <img
        className="logo-horizontal"
        alt="Logo horizontal"
        src={logoHorizontalBlanco}
      />

      <p className="div">Recupera tu contraseña</p>

      <form className="login-form" onSubmit={handleSubmit}>
        <div className="email">
          <input
            type="text"
            value={email}
            onChange={handleEmailChange}
            placeholder="Correo electrónico"
            className="input-field"
            required
          />
          {emailError && <p className="error-message">{emailError}</p>}
        </div>

        <button type="submit" className="iniciar-sesion">
          Enviar enlace de recuperación
        </button>

        <div className="register-link" onClick={() => navigate('/login')}>
          Regresar al inicio de sesión
        </div>
      </form>
    </div>
  );
};

export default PasswordResetRequest;
